import throttle from "lodash/throttle";

import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";

import type { KeywordItemSchema } from "./types";

export const getListOfNewKeywords = (
    newKeywordsList: Array<string>,
    existingKeywordsList: Array<KeywordItemSchema>,
) => {
    const keywordsLimit = ActivationComponentAssets.maxAmountOfKeywords;

    if (newKeywordsList.length) {
        const existingKeywords = existingKeywordsList.map((keyword) => keyword.value);
        let newKeywordsAdded: Array<KeywordItemSchema> = [];

        let isNewKWReduced = false;

        newKeywordsList.forEach((newKeyword) => {
            const newKeywordTrim = newKeyword.trim();

            if (newKeywordTrim && !existingKeywords.includes(newKeywordTrim)) {
                newKeywordsAdded.push({ value: newKeywordTrim, isSelected: false });

                return;
            }
        });

        if (
            newKeywordsAdded.length > keywordsLimit ||
            existingKeywordsList.length + newKeywordsAdded.length > keywordsLimit
        ) {
            newKeywordsAdded = newKeywordsAdded.slice(0, keywordsLimit - existingKeywordsList.length);
            isNewKWReduced = true;
        }

        return {
            newKeywordsAdded,
            initialNewKWListCount: newKeywordsList.length,
            isNewKWReduced,
        };
    }

    return {
        newKeywordsAdded: [],
        addedNewKWCount: 0,
        initialNewKWListCount: newKeywordsList.length,
        isNewKWReduced: false,
    };
};

export const getSearchResults = throttle((query, savedKeyword) => {
    if (query.trim()) {
        return savedKeyword.filter((keyword) => {
            if (keyword.value.match(query)) {
                return keyword;
            }
        });
    }

    return savedKeyword || [];
}, 300);
